import './title.css';

const Title = ({title, desc}) => {

      return (
            <div className="box_title">
                  <h1>{title}</h1>
                  <p>{desc}</p>
            </div>
      )
}

export default Title;